// src/config/be.config.ts — SCE Issues
// Les personnes du bureau d'études (BE) de chaque métier : destinataires
// proposés d'office par « Envoyer au BE » (fiche problème, 20/10).
//
// Des personnes NOMMÉES (décision de Guillaume du 16/10), pas un canal Teams
// ni une liste de diffusion : chacune reçoit la carte Teams et/ou le mail du
// flow 6. Le coordinateur peut en retirer ou ajouter quelqu'un de l'annuaire
// au moment d'envoyer ; rien n'est retenu.
//
// Un métier sans personne (PROCESS) : la fenêtre le dit et demande de choisir
// quelqu'un dans l'annuaire.

import type { Metier } from '@/types/issue.types'
import { rolesCharges } from './registreRoles'

export interface PersonneBE {
  /** « Prénom Nom », comme l'affiche l'appli. */
  nom: string
  /** Adresse = userPrincipalName : c'est elle que le flow 6 utilise. */
  upn: string
}

// Listes données par Guillaume le 21/10 (ELEC, MECA) et le 22/10 (AUTOM : un BE à
// part, l'électricité gardant le sien). PROCESS : pas de BE nommé, la fenêtre fait
// choisir dans l'annuaire.
const BE_ELEC: PersonneBE[] = [
  { nom: 'Dorian Strauss', upn: 'dorian.strauss1@sartorius.com' },
  { nom: 'Adrien Herrmann', upn: 'adrien.herrmann1@sartorius.com' },
  { nom: 'Aurélien Parisse', upn: 'aurelien.parisse@sartorius.com' },
]

const BE_AUTOM: PersonneBE[] = [
  { nom: 'Olivier Parenty', upn: 'olivier.parenty@sartorius.com' },
  { nom: 'Selim Chalah', upn: 'selim.chalah@sartorius.com' },
  { nom: 'Michael Bourdon', upn: 'michael.bourdon@sartorius.com' },
  { nom: 'Hocine Aitouazzou', upn: 'hocine.aitouazzou@sartorius.com' },
  { nom: 'Abdelhadi Aziz', upn: 'abdelhadi.aziz1@sartorius.com' },
]

const BE_MECA: PersonneBE[] = [
  { nom: 'Alexandre Thirion', upn: 'alexandre.thirion@sartorius.com' },
  { nom: 'Mohamed Maarouf', upn: 'mohamed.maarouf1@sartorius.com' },
  { nom: 'Bekir Kilic', upn: 'bekir.kilic@sartorius.com' },
  { nom: 'Adrien Raffo', upn: 'adrien.raffo@sartorius.com' },
]

/** Valeurs par défaut : le panneau d'administration (22/10) les remplace dès qu'on y enregistre le BE. */
export const BE_PAR_METIER_DEFAUT: Record<Metier, PersonneBE[]> = {
  ELEC: BE_ELEC,
  AUTOM: BE_AUTOM,
  MECA: BE_MECA,
  PROCESS: [],
}

/**
 * « Envoyer au BE » ouvert aux coordinateurs ? Faux = grisé avec la mention
 * « En cours » (l'administrateur garde l'accès). Grisé du 20 au 21/10, le temps
 * de construire le flow 6 et de recevoir les noms du BE ; ouvert le 21/10
 * (liste SCE_Envois créée, flow 6 prêt).
 */
export const ENVOI_BE_OUVERT_DEFAUT = true

/** Ouvert ou non : l'interrupteur du panneau d'administration (Ouvertures), sinon la valeur d'ici. */
export function envoiBEOuvert(): boolean {
  return rolesCharges()?.ouvertures.envoiBE ?? ENVOI_BE_OUVERT_DEFAUT
}

/** Les personnes du BE d'un métier (copie : la fenêtre la modifie). */
export function getBE(metier: Metier): PersonneBE[] {
  const liste = rolesCharges()?.be[metier] ?? BE_PAR_METIER_DEFAUT[metier]
  return liste.map((p) => ({ ...p }))
}

/** Les métiers dont `upn` fait partie du BE (page « Pour le BE », 24/10) ; [] pour les autres. */
export function metiersDuBE(upn: string): Metier[] {
  const cle = upn.trim().toLowerCase()
  if (!cle) return []
  return (Object.keys(BE_PAR_METIER_DEFAUT) as Metier[]).filter((m) => getBE(m).some((p) => p.upn.trim().toLowerCase() === cle))
}
